import { useFormik } from "formik";
import { Grid } from "@material-ui/core";

import { IsMobile } from "utils/is-mobile";

import InputText from "components/_refactor/text/input";

export default function Filters({ isLoading, filters, setFilters }) {
  const isMobile = IsMobile();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      search: filters.search,
    },
    onSubmit: () => {},
  });

  const handleChange = (key, value) => {
    formik.setFieldValue(key, value);
    setFilters(key, value);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2} style={{ padding: "1rem 0" }}>
        <Grid item xs={12} md={6} lg={5} xl={3}>
          <InputText
            placeholder="Pesquisar por nome dos representantes"
            onChange={(e) => handleChange("search", e.target.value)}
            disabled={isLoading}
            required={false}
            value={formik.values.search}
            className="form-control"
            style={{ width: "100%" }}
            label="Pesquisar representantes"
          />
        </Grid>
      </Grid>
    </form>
  );
}
